// extracted by mini-css-extract-plugin
export default {"spinCenter":"spinCenter_aTTrW"};